import { render, staticRenderFns } from "./SGShardedClusterOverview.vue?vue&type=template&id=b8348e3a&scoped=true"
import script from "./SGShardedClusterOverview.vue?vue&type=script&lang=js"
export * from "./SGShardedClusterOverview.vue?vue&type=script&lang=js"
import style0 from "./SGShardedClusterOverview.vue?vue&type=style&index=0&id=b8348e3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8348e3a",
  null
  
)

export default component.exports